import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";

const Help = (props) => {
  const { helpShowHide, handleHelpShowHide, module, helpDocs } = props;
  const [viewerSrc, setViewerSrc] = useState("");

  const helpDocUrl = useMemo(() => {
    if (!helpDocs) return "";
    if (typeof helpDocs === "string") return helpDocs;
    return helpDocs.uploadUrl || "";
  }, [helpDocs]);

  useEffect(() => {
    if (!helpDocUrl || !helpShowHide) {
      setViewerSrc("");
      return undefined;
    }

    let objectUrl = "";
    let isCancelled = false;

    const loadPdf = async () => {
      try {
        const response = await fetch(helpDocUrl);
        if (!response.ok) throw new Error("Unable to load help document.");

        const blob = await response.blob();
        objectUrl = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));
        if (!isCancelled) {
          setViewerSrc(`${objectUrl}#toolbar=0&navpanes=0&scrollbar=0`);
        }
      } catch (error) {
        if (!isCancelled) {
          setViewerSrc(`${helpDocUrl}#toolbar=0&navpanes=0&scrollbar=0`);
        }
      }
    };

    loadPdf();

    return () => {
      isCancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [helpDocUrl, helpShowHide]);

  return (
    <Modal show={helpShowHide} size="xl">
      <Modal.Header closeButton onHide={handleHelpShowHide}>
        <Modal.Title>{module === "Support" ? "Add Issue" : "Help"}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="border">
        {module === "Support" && (
          <div className="row border bg-white pt-3 pb-3 rounded">
            <div className="col-md-12 form-group">
              <h3>Welcome to our Customer Support Portal!</h3>
            </div>
            <div className="col-md-12 form-group">
              <p>
                In this portal we offer you an easy way to register any issue you may encounter while working and using
                various functions and features.
              </p>
            </div>
            <div className="col-md-12 form-group">
              <p>
                Once you register an issue and submit, it will be received by our dedicated and committed customer and
                technical support staff who will review and provide instant fix(s), if required.
              </p>
            </div>
            <div className="col-md-12 form-group">
              <p>Our customer and technical support staff will also update and notify you of the action taken.</p>
            </div>
            <div className="col-md-12 form-group">
              <h3>Thank you.</h3>
              <h3>WorkFINITY®</h3>
              <h3>Customer and Technical Support</h3>
            </div>
          </div>
        )}

        {helpDocUrl && (
          <div style={{ height: "600px", width: "860px", margin: "auto" }}>
            {viewerSrc && (
              <iframe
                title="Help PDF Viewer"
                src={viewerSrc}
                width="100%"
                height="100%"
                style={{ border: "none" }}
              />
            )}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default Help;
